<template>
  <!-- Ele vive, Ele reina, Ele é Deus e senhor -->
  <div id="app-raiz" v-if="pronto">
    <!-- Telas públicas (ex.: relógio itinerante no tablet) -->
    <router-view v-if="$route.meta.publico" />

    <Login v-else-if="!logado" @logado="aoLogar" />

    <div v-else class="shell">
      <sider />
      <div class="shell-conteudo">
        <mcabecalho />
        <main class="shell-pagina">
          <router-view />
        </main>
      </div>
      <GlobalLoading />
    </div>
  </div>
</template>

<script>
// ☧  ✟
//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);
//Creio em ti Senhor e Deus meu, porque tu és a minha força e o meu refúgio. (Salmo 31:14-15);

import sider from '@/components/sider.vue'
import mcabecalho from '@/components/mcabecalho.vue'
import Login from '@/components/Login.vue'
import util from '@/util'

export default {
  name: 'app',
  components: { sider, mcabecalho, Login },
  data() {
    return {
      pronto: false,
      logado: false,
    }
  },
  async created() {
    const s = util.sessao()
    // Sessões antigas (sem token) precisam de novo login.
    if (s && s.token) {
      this.$store.commit('definelogin', s)
      this.logado = true
      await this.atualizarSessao()
    } else if (s) {
      localStorage.removeItem('dadosusuario')
    }
    await this.$router.isReady()
    this.pronto = true
  },
  methods: {
    /** Permissões podem ter mudado desde o login: busca as atuais no servidor. */
    async atualizarSessao() {
      const s = util.sessao()
      try {
        const r = await util.reqaxios([{ parametro: 'op', valor: 'sessao' }, { parametro: 'idempresa', valor: s.idempresa }],
                                      'post', util.servidor + '/controller/rotinalogin.php')
        if (r.data && r.data.ok) {
          const novo = { ...s, nomeusuario: r.data.nomeusuario, admin: r.data.admin, permissoes: r.data.permissoes }
          localStorage.setItem('dadosusuario', JSON.stringify(novo))
          this.$store.commit('definelogin', novo)
        }
      } catch (e) { /* sem rede ou sessão expirada: util já trata o 401 */ }
    },
    aoLogar() {
      this.logado = true
      if (this.$route.path !== '/') this.$router.replace('/')
    },
  },
}
</script>

<style lang="scss">
.shell {
  display: flex;
  min-height: 100vh;
}
.shell-conteudo {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.shell-pagina {
  padding: 22px 24px 40px;
  flex: 1;
}
@media (max-width: 768px) {
  .shell-pagina { padding: 16px; }
}
</style>
